// @flow
import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';
import React from 'react';
import defaultBg from '../../../images/goods.svg';
import defaultBgSp from '../../../images/goods-sp.svg';
import { heroStyles } from './styles';

const Hero = ({
  logoPaidy,
  title,
  subTitle,
  bg,
  bgSp,
  classNames,
}: {
  logoPaidy?: Boolean,
  title?: string,
  subTitle?: string,
  bg?: string,
  bgSp?: string,
}) => {
  const backgroundPc = bg || defaultBg;
  const backgroundSp = bgSp || defaultBgSp;
  const classes = heroStyles({
    backgroundPc,
    backgroundSp,
    subTitle,
    logoPaidy,
  });

  return (
    <Box className={cx(classes.container, classNames)}>
      {logoPaidy && (
        <img
          src={require('../../../images/logo-color-10th.svg')}
          alt="Paidy"
          className={classes.paidyLogo}
        />
      )}
      {title && <Typography variant="h1">{title}</Typography>}
      {subTitle && (
        <Typography variant="h4" component="p">
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

Hero.defaultProps = {
  logoPaidy: false,
  title: '',
  subTitle: '',
  bg: '',
  bgSp: '',
  classNames: '',
};

// $FlowFixMe
export default Hero;
